'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
exports.wrapAndDeduplicate = wrapAndDeduplicate;

var _refTransformer = require('./ref-transformer');

var _wixDataWebmethodStructures = require('wix-data-webmethod-structures');

function wrapAndDeduplicate(items, schema, references) {
  return items.map(function (item) {
    var wrappedItem = (0, _refTransformer.wrapAllReferences)(schema, item);
    if (references) {
      Object.keys(references).filter(function (includedField) {
        return wrappedItem[includedField] && wrappedItem[includedField] instanceof _wixDataWebmethodStructures.Ref;
      }).forEach(function (includedField) {
        var referencedItemId = wrappedItem[includedField].id;
        var referencedItem = references[includedField][referencedItemId];
        wrappedItem[includedField] = new _wixDataWebmethodStructures.Ref(referencedItem || referencedItemId);
      });
    }
    return wrappedItem;
  });
}


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-data-core/lib/postprocessing/ref-deduplicator.js
// module id = 54
// module chunks = 0